import { generateInitialState, createTableSlice } from './tableSlice';

const relationshipCompaniesTableInitialState = generateInitialState();
export const relationshipCompaniesTableSlice = createTableSlice(
	'relationshipCompaniesTable',
	relationshipCompaniesTableInitialState,
);

export const {
	setPageAfter,
	setRowsPerPage,
	setSearchValue,
	setSearchText,
	setOrderBy,
	setOrder,
	setPage,
	setRows,
	resetSearchFields,
	changeRowsPerPage,
	requestSort,
	changePage,
	resetAllPages,
	onOrderChange,
	setSelected,
	triggerRefresh,
} = relationshipCompaniesTableSlice.actions;

export default relationshipCompaniesTableSlice.reducer;
